exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item--chevron[data-v-70aee47e]:before{border-color:#1a1824}.order-details-container[data-v-70aee47e]{text-align:right}.order-date[data-v-70aee47e]{font-size:14px;color:#181d1e;opacity:.5}.order-header[data-v-70aee47e]{font-weight:700;color:#181d1e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70aee47e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/user/orders.vue
// module id = Iju7
// module chunks = 0